const Routes = {
	route: "/",
	title: "Home",
	level: 0,
	children: [
		{
			path: "/individuals",
			title: "Individuals",
			level: 1,
			children: [
				{
					path: "/individuals/healthy-living",
					title: "Healthy Living",
					level: 2,
					children: [
						{
							path: "/individuals/healthy-living/trade-up-for-health",
							title: "Trade Up For Health",
							level: 3,
							children: [
								{
									path: "/individuals/healthy-living/trade-up-for-health/nutrition",
									title: "Nutrition",
									level: 4
								},
								{
									path: "/individuals/healthy-living/trade-up-for-health/physical-activity",
									title: "Physical Activity",
									level: 4
								}
							]
						}
					]
				}
			]
		},
		{
			path: "/community-partners",
			title: "Community Partners",
			level: 1,
			children: [
				{
					path: "/community-partners/toolkits",
					title: "Toolkits",
					level: 2,
					children: [
						{
							path: "/community-partners/toolkits/vape",
							title: "Vape Toolkit",
							level: 3,
							children: [
								{
									path: "/community-partners/toolkits/vape/educators",
									title: "Educators",
									level: 4
								},
								{
									path: "/community-partners/toolkits/vape/parents",
									title: "Parents",
									level: 4
								}
							]
						},
						{
							path: "/community-partners/toolkits/smoke-free-multi-unit-housing",
							title: "Tobacco Multi-Unit Housing Toolkit",
							level: 3,
							children: [
								{
									path: "/community-partners/toolkits/smoke-free-multi-unit-housing/landlord-toolkit",
									title: "Landlords",
									level: 4
								},
								{
									path: "/community-partners/toolkits/smoke-free-multi-unit-housing/tenant-toolkit",
									title: "Tenants",
									level: 4
								},
								{
									path: "/community-partners/toolkits/smoke-free-multi-unit-housing/condo-owner-toolkit",
									title: "Condo Owners",
									level: 4
								}
							]
						}
					]
				}
			]
		}
	]
};

export default Routes;
